import { mapMutations, mapActions, mapState } from "vuex"

import modal from "~/components/shared/modal"
import modal_footer from "~/components/shared/modal/footer"

import resize_mixin from "~/mixins/resize"
import acc_swapper_mixin from "~/mixins/nav/accSwapperFromGuard"

export default {
  mixins: [resize_mixin, acc_swapper_mixin],
  components: {
    modal,
    modal_footer,
  },
  computed: {
    ...mapState({
      DISPLAY: (state) => state.misc.draft.display,
      DRAFT_ID: (state) => state.draft.id,
      TRACK: (state) => state.draft.track,
      TRACK_PATCH: (state) => state.misc.draft.track_backup,
      DRAFT_PATCH: (state) => state.misc.draft.draft_backup,
      IS_LOGIN_OUT: (state) => state.misc.draft.login_out,
      ROUTE: (state) => state.misc.draft.route,
      BAND_PATCH: (state) => state.misc.draft.band_patch,
      SWAP_ACCOUNT: (state) => state.misc.draft.swap_account,
    }),
  },
  methods: {
    deleteDraft: async function () {
      await this.DELETE_DRAFT(this.DRAFT_ID)
      this.commonLogic()
    },
    saveDraft: async function () {
      if (Object.keys(this.DRAFT_PATCH).length) {
        await this.UPDATE_DRAFT(this.DRAFT_PATCH)
      }
      if (Object.keys(this.TRACK_PATCH).length) {
        const { id } = await this.UPDATE_TRACK({
          ...this.TRACK,
          ...this.TRACK_PATCH,
        })
        await this.BIND_TRACK_TO_DRAFT(id)
      }
      if (!this.IS_LOGIN_OUT) {
        this.createDraftSnackbar()
        this.createTrackSnackbar()
      }
      this.commonLogic()
    },
    commonLogic: async function () {
      if (this.BAND_PATCH > 0) this.PATCH_BAND(this.BAND_PATCH)

      this.RESET_UNSAVED()
      this.SET_IN_FLOW(false)

      if (Object.keys(this.SWAP_ACCOUNT).length > 0)
        this.prepareAccountSwap(this.SWAP_ACCOUNT.pk, this.SWAP_ACCOUNT.email)

      await this.REMOVE_FROM_CURRENT()
      this.CART_RESET()

      if (this.IS_LOGIN_OUT === true) await this.LOG_OUT()
      else {
        this.MISC_DRAFT_RESET()
        this.SET_IS_ALIVE(false)
        this.$router.push(this.ROUTE)
      }
    },
    createDraftSnackbar: function () {
      this.CREATE_SNACKBAR({
        props: {
          text: this.$t("draft.snackbar"),
          icon: "fas fa-check",
        },
      })
    },
    createTrackSnackbar: function () {
      window.setTimeout(
        function () {
          this.CREATE_SNACKBAR({
            props: {
              text: this.$t("track.snackbar"),
              icon: "fas fa-check",
            },
          })
        }.bind(this),
        1500
      )
    },
    ...mapActions({
      REMOVE_FROM_CURRENT: "draft/RESET_CURRENT",
      BIND_TRACK_TO_DRAFT: "draft/BIND_TRACK",
      MISC_DRAFT_RESET: "misc/draft/RESET",
      SET_DISPLAY: "misc/draft/SET_DISPLAY",
      DELETE_DRAFT: "draft/DELETE",
      UPDATE_DRAFT: "draft/UPDATE",
      UPDATE_TRACK: "draft/track/UPDATE_ON_SERVER",
      CREATE_SNACKBAR: "snackbar/CREATE",
      CART_RESET: "cart/RESET",
      LOG_OUT: "user/LOGOUT",
      PATCH_BAND: "user/band/PATCH",
    }),
    ...mapMutations({
      RESET_UNSAVED: "misc/draft/RESET_UNSAVED",
      SET_IN_FLOW: "misc/draft/SET_IN_FLOW",
      SET_IS_ALIVE: "misc/draft/SET_IS_ALIVE",
    }),
  },
}
